import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6de919a9")

_pushScopeId("data-v-6de919a9")
const _hoisted_1 = { class: "dt-open-api-doc-left-menu-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "dt-open-api-doc-left-menu-top" }, " API说明 ", -1)
const _hoisted_3 = { class: "dt-open-api-left-menu-box" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_menu = _resolveComponent("el-menu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_el_menu, {
        "default-active": _ctx.curMenuId,
        class: "el-menu-vertical-demo",
        onOpen: _ctx.handleOpen,
        onClose: _ctx.handleClose
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menuList, (item) => {
            return (_openBlock(), _createBlock(_Fragment, {
              key: item.id
            }, [
              (item.children && item.children.length > 0)
                ? (_openBlock(), _createBlock(_component_el_submenu, {
                    key: 0,
                    index: item.id
                  }, {
                    title: _withId(() => [
                      _createVNode("span", null, _toDisplayString(item.title), 1)
                    ]),
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children, (subItem) => {
                        return (_openBlock(), _createBlock(_component_el_menu_item, {
                          index: subItem.id,
                          key: subItem.id,
                          onClick: $event => (_ctx.openGroupApi(subItem))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(subItem.title), 1 /* TEXT */)
                          ]),
                          _: 2
                        }, 1032, ["index", "onClick"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 2
                  }, 1032, ["index"]))
                : (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 1,
                    index: item.id,
                    onClick: $event => (_ctx.changeCurMenu(item))
                  }, {
                    title: _withId(() => [
                      _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                    ]),
                    _: 2
                  }, 1032, ["index", "onClick"]))
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1
      }, 8, ["default-active", "onOpen", "onClose"])
    ])
  ]))
})